import React from 'react';

/**
 * Sale-status pill for a deal.
 * status: 'available' | 'under_contract' | 'sold'
 */
export default function DealStatusPill({ status = 'available', className = '' }) {
  const s = (status || 'available').toLowerCase();
  const map = {
    available: { label: 'Available', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
    under_contract: { label: 'Under Contract', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
    sold: { label: 'Sold', cls: 'bg-slate-100 text-slate-600 border-slate-200' },
  };
  const info = map[s] || map.available;
  return (
    <span
      className={`inline-flex items-center rounded-full border font-medium text-xs px-2.5 py-1 ${info.cls} ${className}`}
      data-testid={`deal-status-${s}`}
    >
      {info.label}
    </span>
  );
}
